import Service, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { queryManager } from 'ember-apollo-client';
import { task } from 'ember-concurrency';

import requestAppointmentNotePrint from 'my-phorest/gql/mutations/request-appointment-note-print.graphql';

export default class SelectedNotePrinterService extends Service {
  @service session;
  @service electronApp;
  @service printingDevices;
  @service router;
  @service('browser/window') window;

  @queryManager apollo;

  @tracked isPrinting = false;
  @tracked clientId;
  @tracked date;
  @tracked branchId;

  print({ clientId, date, branchId }, { forceLocalPrinting = false } = {}) {
    this.clientId = clientId;
    this.date = date;
    this.branchId = branchId;

    if (this.electronApp.isRunningInElectron) {
      this.printInElectronTask.perform(forceLocalPrinting);
    } else {
      this.isPrinting = true;
    }
  }

  @task
  *printInElectronTask(forceLocalPrinting = false) {
    yield this.electronApp.verifyHasPrinterToPrintTo();

    if (!forceLocalPrinting) {
      const remoteTargetId = yield this.electronApp.getRemotePrintingTarget();

      if (remoteTargetId) {
        const result = yield this.apollo.mutate(
          {
            mutation: requestAppointmentNotePrint,
            variables: {
              clientId: this.clientId,
              date: this.date,
              printingDeviceId: remoteTargetId,
            },
          },
          'requestAppointmentNotePrint'
        );
        this.printingDevices.showPrintRequestSentSuccessNotificationTask.perform(
          remoteTargetId
        );
        return result;
      }
    }

    const path = this.router.urlFor(
      'accounts.account.print.selected-note',
      this.session.currentAccountId,
      this.clientId,
      this.date,
      this.branchId
    );
    const { protocol, host } = this.window.location;
    const printURL = new URL(`${protocol}//${host}${path}`);

    return yield new Promise((resolve) => {
      return this.electronApp.printReceipt(
        printURL.toString(),
        {
          successCb: () => {
            this.isPrinting = false;
            resolve();
          },
        },
        {
          waitForDataLoadedAttr: true,
        }
      );
    });
  }

  @action
  onDone() {
    this.isPrinting = false;
  }
}
